import * as identify from "utils/treeUtils";
import type { Node } from "interfaces/schemas";
import { ProjectQry } from "api/queries";
import { gqlFetchWithAuth } from "utils/fetchData/gqlFetchWithAuth";
import { buildTree } from "utils/treeUtils";

export const isProjectContainsProducts = (
  nodeOrNodes: Node | Node[] | null,
): boolean => {
  if (!nodeOrNodes) {
    return false;
  }

  const nodes = Array.isArray(nodeOrNodes) ? nodeOrNodes : [nodeOrNodes];

  return nodes.some(
    (node) =>
      identify.isAnyProduct(node) ||
      (Array.isArray(node.nodes) && isProjectContainsProducts(node.nodes)),
  );
};

export const checkProjectContainsProducts = async (
  projectId: string,
): Promise<boolean> => {
  const { project } = await gqlFetchWithAuth({
    query: ProjectQry,
    variables: { input: { id: projectId } },
  });

  if (!project) {
    return false;
  }

  if (!project.title) {
    throw new Error("Project should have a title");
  }

  const tree = buildTree(project.projectNodes, project.id, project.title);
  return isProjectContainsProducts(tree);
};
